import { render, staticRenderFns } from "./Prefactura.vue?vue&type=template&id=cd9252ca&"
import script from "./Prefactura.vue?vue&type=script&lang=js&"
export * from "./Prefactura.vue?vue&type=script&lang=js&"
import style0 from "./Prefactura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports